import { render } from "./MapDataEditor.vue?vue&type=template&id=9830a8c2"
import script from "./MapDataEditor.vue?vue&type=script&lang=js"
export * from "./MapDataEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__